import { Box, Modal, Typography, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Close } from "@mui/icons-material";
import parse from "html-react-parser";
import React, { useState } from "react";
const useStyles = makeStyles((theme) => ({
  questionNumber: {
    fontFamily: "Inter",
    color: "#475569",
    fontWeight: 500,
    fontSize: "18px",
    [theme.breakpoints.down("sm")]: {
      fontWeight: 600,
      fontSize: "15px",
    },
  },
  questionTitle: {
    fontFamily: "Inter",
    color: "#475569",
    fontSize: "18px !important",
    wrap: "auto",
    fontWeight: "700 !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "15px !important",
      fontWeight: "600 !important",
    },
  },
  questionSubTitle: {
    fontFamily: "Inter",
    fontWeight: "Regular",
    color: "#94a3b8",
    fontSize: "15px",
    marginBottom: "10px",
    wrap: "auto",
    fontStyle: "italic",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      marginBottom: "10px",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    [theme.breakpoints.down("sm")]: {
      padding: "4px",
      alignItems: "flex-start",
      paddingTop: "20px",
    },
  },
  modalContent: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "20px",
    maxWidth: "600px",
    width: "90%",
    maxHeight: "80vh",
    overflow: "hidden",
    outline: "none",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: "12px !important",
      width: "98%",
      maxHeight: "85vh",
      maxWidth: "none",
    },
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px !important",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: "12px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px !important",
      paddingBottom: "8px",
    },
  },
  modalTitle: {
    fontFamily: "Inter",
    fontSize: "18px",
    fontWeight: 600,
    color: "#334155",
    flex: 1,
    marginRight: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 700,
    },
  },
  modalBody: {
    fontFamily: "Inter",
    fontSize: "14px",
    color: "#475569",
    lineHeight: "1.6",
    overflow: "auto",
    flex: 1,
    "& img": {
      maxWidth: "100%",
      borderRadius: "4px",
      marginBottom: "8px",
      display: "block",
    },
    "& p": {
      marginBottom: "8px",
      wordWrap: "break-word",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "1.4",
      "& img": {
        maxHeight: "200px",
        objectFit: "cover",
        width: "100%",
      },
    },
  },
  guidanceImage: {
    width: "260px",
    height: "260px",
  },
  requiredLabel: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    color: "#FF4B4B",
    marginLeft: "4px",
  },
}));

function QuestionWrapper(props) {
  const {
    question,
    questionNumber,
    questionTitle,
    questionSubTitle,
    myRef,
    required,
    isGreyOut,
    showCategory,
    questionCategory,
    questionType,
    hideQuestionNumber,
  } = props;
  const classes = useStyles(props);
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <Box
      style={{ width: "100%", paddingLeft: "5px", marginBottom: "3%" }}
      ref={myRef}
    >
      {questionType !== "director_message" ? (
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
          }}
        >
          {!hideQuestionNumber ? (
            <Typography className={classes.questionNumber}>
              {questionNumber && questionNumber}.&nbsp;
            </Typography>
          ) : null}
          <Box>
            {showCategory ? (
              <Typography className={classes.questionTitle}>
                {questionCategory}
              </Typography>
            ) : null}
            <Typography className={classes.questionTitle}>
              {questionTitle && parse(questionTitle)}
              {required && <span className={classes.requiredLabel}>required*</span>}
              {question?.unit ? (
                <span className="ms-1">
                  {question?.unit ? `(${question.unit})` : null}
                </span>
              ) : null}
              {question?.questionGuidance ? (
                <>
                  <i
                    className="fa fa-info-circle ms-1"
                    style={{ cursor: "pointer" }}
                    onClick={handleModalOpen}
                  ></i>
                  <Modal
                    open={modalOpen}
                    onClose={handleModalClose}
                    className={classes.modal}
                  >
                    <Box className={classes.modalContent}>
                      <Box className={classes.modalHeader}>
                        <Typography className={classes.modalTitle}>
                          Question Guidance
                        </Typography>
                        <IconButton
                          onClick={handleModalClose}
                          size="small"
                          style={{
                            color: "#64748b",
                            padding: "8px",
                            minWidth: "40px",
                            minHeight: "40px",
                          }}
                        >
                          <Close />
                        </IconButton>
                      </Box>
                      <Box className={classes.modalBody}>
                        {question?.questionGuidance
                          ? parse(question?.questionGuidance)
                          : ""}
                        {question?.questionGuidanceImages?.length ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: "10px",
                              marginTop: "10px",
                            }}
                          >
                            {question?.questionGuidanceImages?.map((image) => (
                              <img
                                src={image}
                                alt="question"
                                className={classes.guidanceImage}
                              />
                            ))}
                          </div>
                        ) : null}
                      </Box>
                    </Box>
                  </Modal>
                </>
              ) : null}
            </Typography>
            <Typography className={classes.questionSubTitle}>
              {questionSubTitle ?? ""}
            </Typography>
          </Box>
        </Box>
      ) : null}

      {question?.images?.length ? (
        <div className="ms-2 mt-1 mb-3 d-flex align-items-center">
          {question.images.map((image) => (
            <div
              style={{
                marginRight: "1rem",
                border: "1px solid gainsboro",
                padding: "3px",
                borderRadius: "4px",
              }}
            >
              <img
                src={image}
                alt="question"
                width="125px"
                height="125px"
                style={{ objectFit: "contain" }}
              />
            </div>
          ))}
        </div>
      ) : null}

      {props.children}
    </Box>
  );
}

export default QuestionWrapper;
